import { CommonSubmittalUtils } from './CommonSubmittalUtils';
import DateUtils from './DateUtils';
export class TimelineUtils {
    /**
     * Same as {@link getTimelineBubbles}, but completed steps come from STATUS feed items
     * (`sub_id` = state id). Current/pending slices use `completedStateIndex` as the authority
     * (`undefined` = draft → treat as -1).
     */
    static getTimelineBubblesFromFeed(history, states, calendar, completedStateIndex, today = DateUtils.currentDate) {
        const historyBubbles = history.map((item, index) => {
            const doneDate = DateUtils.fromISO(item.date);
            const stateId = item.sub_id;
            const stateIndex = states.findIndex((s) => s.id === stateId);
            const state = states.find((s) => s.id === stateId);
            let dueDate = doneDate;
            if (index > 0 && state) {
                const prevItem = history[index - 1];
                const previousStateIndex = states.findIndex((s) => s.id === prevItem.sub_id);
                dueDate = this.getStateDueDate(state, DateUtils.fromISO(prevItem.date), calendar);
                if (previousStateIndex > stateIndex) {
                    return {
                        id: stateId,
                        dueDate,
                        doneDate: doneDate,
                        people: item.user_id ? [item.user_id] : [],
                        showBackArrow: true,
                    };
                }
            }
            return {
                id: stateId,
                dueDate,
                doneDate: doneDate,
                people: item.user_id ? [item.user_id] : [],
                label: state?.pastTense ?? state?.action ?? '',
            };
        });
        const lastStatusItem = history.length > 0 ? history[history.length - 1] : null;
        const completedIndex = completedStateIndex ?? -1;
        const currentState = completedIndex < states.length - 1 ? states[completedIndex + 1] : null;
        let anchorDate = today;
        if (currentState) {
            const lastBubbleDoneDate = lastStatusItem ? DateUtils.fromISO(lastStatusItem.date) : today;
            const dueDate = this.getStateDueDate(currentState, lastBubbleDoneDate, calendar);
            // If the due date is in the past, we use current date as the anchor date.
            anchorDate = new Date(Math.max(dueDate.getTime(), anchorDate.getTime()));
            historyBubbles.push({
                id: currentState.id,
                dueDate: dueDate,
                doneDate: anchorDate, // current state is not done, but this predicts the done date if its completed right now.
                people: currentState.dueBy ?? [],
                label: currentState.action,
            });
        }
        const pendingBubbles = states.slice(completedIndex + 2).map((state) => {
            const dueDate = CommonSubmittalUtils.getStateDueDate(state, anchorDate, calendar);
            anchorDate = dueDate;
            return {
                id: state.id,
                dueDate: dueDate,
                people: state.dueBy ?? [],
                label: state.action,
            };
        });
        return [...historyBubbles, ...pendingBubbles];
    }
    static getStateDueDate(state, previousDoneDate, calendar) {
        if (!state || !state.dueDays || state.dueDays <= 0)
            return previousDoneDate;
        const durationInSeconds = calendar.workingDaysToSeconds(state.dueDays);
        return calendar.getDateFromPositiveDuration(previousDoneDate, durationInSeconds);
    }
    /**
     * Due date at the end of all remaining workflow states after `fromIndex`.
     * `fromIndex` is the last completed state index (`-1` or `undefined` = none completed).
     * Returns null when there are no pending states.
     */
    static getWorkflowDueDate(states, fromIndex, anchorDate, calendar) {
        if (!anchorDate)
            return null;
        const pendingStates = states.slice((fromIndex ?? -1) + 1);
        if (pendingStates.length === 0)
            return null;
        let dueDate = anchorDate;
        pendingStates.forEach((state) => {
            dueDate = TimelineUtils.getStateDueDate(state, dueDate, calendar);
        });
        return dueDate;
    }
}
